import { render, staticRenderFns } from "./IndirilecekEvrakTuruPicker.vue?vue&type=template&id=7b70a0a5"
import script from "./IndirilecekEvrakTuruPicker.vue?vue&type=script&lang=ts"
export * from "./IndirilecekEvrakTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports